import { alpha, mixWhite } from '@wojtekmaj/color-utils';

const colors = {
  background: '#242633',
  'background-1': '#2b2d40',
  'background-2': '#1d1d24',
  'card-background': '#2d3040',
  'dialog-background': '#242633',
  link: '#e10067',
  'menu-background': '#242633',
  green: '#119947',
  lime: '#a3c612',
  orange: '#d96032',
  overlay: alpha('#ffd300', 0.5),
  'overlay-fallback': mixWhite('#ffd300', 0.5),
  primary: '#e10067',
  'primary-button-background': '#e10067',
  'primary-button-disabled-background': '#e10067',
  'primary-button-disabled-text': '#ffffff',
  'primary-button-focus-background': '#e10067',
  'primary-button-focus-text': '#ffffff',
  'primary-button-hover-background': '#b82e36',
  'primary-button-hover-text': '#ffffff',
  'primary-button-text': '#ffffff',
  purple: '#9b298b',
  'secondary-button-background': '#00000000',
  'secondary-button-disabled-background': '#00000000',
  'secondary-button-disabled-text': '#e10067',
  'secondary-button-focus-background': '#00000000',
  'secondary-button-focus-text': '#e10067',
  'secondary-button-border-color': '#e10067',
  'secondary-button-hover-background': '#e10067',
  'secondary-button-hover-text': '#ffffff',
  'secondary-button-text': '#e10067',
  teal: '#00a7cc',
  text: '#ffffff',
  'text-light': alpha('#ffffff', 0.75),
  'text-muted': alpha('#ffffff', 0.25),
  'text-on-white': '#3b3636',
  'text-on-white-light': '#787474',
  'text-on-white-muted': '#b5b2b2',
  'toggle-background': '#c9d9e8',
  'toggle-active-background': '#e10067',
  yellow: '#ffd300',
  'yellow-dark': '#e8c104',
  /* Inherited colors */
  black: '#231f20',
  'error-dark': '#c50606',
  'error-light': '#ff746b',
  'error-background': alpha('#ff2323', 0.1),
  gray: '#c9d9e8',
  'gray-light': '#f2f6f8',
  'info-dark': '#026f9c',
  'info-light': '#2ec1ff',
  'info-background': alpha('#00b4ff', 0.1),
  'orange-light': '#fbc288',
  'primary-dark': '#b82e36',
  'primary-light': alpha('#df3842', 0.1),
  secondary: '#a16b46',
  'secondary-dark': '#805437',
  'secondary-light': alpha('#a16b46', 0.1),
  'success-dark': '#106d1f',
  'success-light': '#74d884',
  'success-background': alpha('#2aac3f', 0.1),
  'warning-dark': '#85722f',
  'warning-light': '#ffdd66',
  'warning-background': alpha('#ffdd66', 0.15),
  white: '#ffffff',
} as const;

export default colors;
